/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Meals = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <g clipPath="url(#clip0_10306_318)">
                        <path
                            d="M4.75 8.94C4.75 10.62 6.11 11.98 7.79 11.98H8.3C9.98 11.98 11.34 10.62 11.34 8.94"
                            stroke={color}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                        />
                        <path
                            d="M19.51 22.26V3.75"
                            stroke={color}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                        />
                        <path
                            d="M8.03998 22.26V11.98"
                            stroke={color}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                        />
                        <path
                            d="M4.75 3.26999V9.04999"
                            stroke={color}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                        />
                        <path
                            d="M8.03998 3.26999V8.88999"
                            stroke={color}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                        />
                        <path
                            d="M11.33 3.26999V9.13999"
                            stroke={color}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                        />
                        <path
                            d="M19.51 3.75V15.65H17.44C16.24 15.65 15.3 14.62 15.4 13.43L15.94 7.03C16.1 5.18 17.65 3.75 19.51 3.75Z"
                            stroke={color}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_10306_318">
                            <rect
                                width="16.26"
                                height="19.26"
                                fill="white"
                                transform="translate(4 3)"
                            />
                        </clipPath>
                    </defs>
                </svg>
        );
    };
